const adminApiBaseUrl = (
  process.env.REACT_APP_PAYMENT_API_URL ||
  'https://southamerica-east1-coloniadeferiasss.cloudfunctions.net/paymentApi'
).replace(/\/$/, '');

export interface PessoaRetiradaTermo {
  nome: string;
  cpf: string;
}

export interface TermoAutorizacaoPayload {
  inscricaoId: string;
  nomeResponsavel: string;
  cpfResponsavel: string;
  telefoneResponsavel: string;
  telefoneEmergencia: string;
  alergias: string;
  medicamentos: string;
  restricoesAlimentares: string;
  outrasInformacoes: string;
  convenioMedico: string;
  numeroCarteirinha: string;
  autorizaImagem: boolean;
  pessoasRetirada: PessoaRetiradaTermo[];
  assinaturaUrl: string;
}

export const enviarTermoAutorizacao = async (payload: TermoAutorizacaoPayload): Promise<string> => {
  const response = await fetch(`${adminApiBaseUrl}/termos-autorizacao`, {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(payload)
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok || !data.success) throw new Error(data.error || 'Não foi possível enviar o termo.');
  return data.termoId as string;
};

export interface TermoAutorizacaoRegistro extends TermoAutorizacaoPayload {
  id: string;
  nomeCrianca: string;
  turma?: string;
  createdAt?: unknown;
}

export const fetchTermosAutorizacao = async (): Promise<TermoAutorizacaoRegistro[]> => {
  const response = await fetch(`${adminApiBaseUrl}/admin/termos-autorizacao`);
  const data = await response.json().catch(() => ({}));
  if (!response.ok || !data.success) throw new Error(data.error || 'Não foi possível carregar os termos.');
  return Array.isArray(data.termos) ? data.termos : [];
};
